import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Layout, Menu } from 'antd';
import menu from '@/menu';
import MenuGroupItem from '@/components/Menu/MenuGroupItem';
import MenuItem from '@/components/Menu/MenuItem';

const { Sider } = Layout;

class AppSidebar extends Component {

    onClickMenu(item, key, keyPath) {
        this.props.history.push(key)
    }

    render() {
        var { pathname } = this.props.location;
        const { collapsed, onCollapse } = this.props;

        return (
            <Sider
                collapsed={collapsed}
                theme="light"
                width={250}
                className="site-layout-background ecom-menu"
                collapsible
                onCollapse={onCollapse}
                collapsedWidth={55}
                style={{
                    height: '100vh',
                    position: 'fixed',
                    left: 0,
                    top: 0,
                    bottom: 0,
                    overflow: 'hidden',
                    zIndex: 998
                }}
            >
                <div style={{ height: '48px' }} />
                <div
                    className="custom-scrollbar"
                    style={{
                        height: 'calc(100vh - 100px)',
                        overflowY: 'auto',
                        overflowX: 'hidden'
                    }}
                >
                    <Menu
                        mode="inline"
                        selectedKeys={[pathname]}
                        style={{ height: '100%', borderRight: 0 }}
                        onClick={({ item, key, keyPath }) => this.onClickMenu(item, key, keyPath)}
                    >
                        {
                            menu.map((item, key) => {
                                if (item.children) {
                                    return <MenuGroupItem item={item} key={key} />
                                } else {
                                    return <MenuItem item={item} key={item.path} />
                                }
                            })
                        }
                    </Menu>
                </div>
            </Sider>
        )
    }
}

function mapStateToProps(state) {
    return {
        authUser: state.auth.authUser,
        config: state.config
    }
}

export default withRouter(connect(mapStateToProps)(AppSidebar));